import Swal from "sweetalert2";
// icons svg
import success from "../assets/success-icon.svg";
import confirmDelete from "../assets/image-confirm.png";
import networkError from "../assets/network-error.png";
import errorImage from "../assets/error-image.png" 

export const SuccessSwal = (item) => {
  Swal.fire({
    imageAlt: "Custom image",
    animation: false,
    html: `<div style="display:flex;justify-content:center;align-items:center;gap:20px;padding:10px;flex-direction: column;"><img src="${success}" alt="success!" style="width:80;height:80px"/><span style="color: #0178c1;font-size:16px;font-weight:700">${item}</span>`,
    showConfirmButton: false,
    timer: 1800,
    width: 320,
    height: 208,
  });
};

export const ErrorSwal = (err) => {
  Swal.fire({
    icon: "error",
    text: err,
    showConfirmButton: false,
    timer: 3000,
  });
};

export const WarningSwal = (text) => {
  Swal.fire({
    icon: "warning",
    text: text,
    showConfirmButton: false,
  });
};

export const WarningNetworkFailure = () => {
  Swal.fire({
    imageAlt: "Custom image",
    animation: false,
    html: `<div style="display:flex;justify-content:center;align-items:center;gap:20px;padding:10px;flex-direction: column;"><img src="${networkError}" alt="success!" style="width:156px;height:112px"/><span style="color: #FF8A00;font-size:18px;font-weight:700">ເຄືອຄ່າຍຂັດຂ້ອງກະລຸນາເຊື່ອມອິນເຕີເນັດ!</span>`,
    showConfirmButton: false,
    width: 420,
    height: 208,
  });
};

export const WarningError = (text) => {
  Swal.fire({
    imageAlt: "Custom image",
    animation: false,
    html: `<div style="display:flex;justify-content:center;align-items:center;gap:20px;padding:10px;flex-direction: column;"><img src="${errorImage}" alt="success!" style="width:87px;height:87px"/><span style="color: #FF0000;font-size:18px;font-weight:700">${text}</span>`,
    showConfirmButton: false,
    width: 420,
    height: 208,
  });
};

export const wariningWithTextAndConfirmButton = (title, detail, onConfirm) => {
  Swal.fire({
    title: title,
    text: detail,
    icon: "success",
    timer: 5000,
  }).then(async () => {
    try {
      await onConfirm();
    } catch (error) {
      console.log("Error: ", error);
    }
  });
};
